/* eslint-disable */
import type { SVGProps, FC } from "react"

const SvgHomeAndUtilityInfo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      data-name="Path 104"
      d="M8 0a8 8 0 1 0 8 8 8.024 8.024 0 0 0-8-8Zm0 2.4a2.357 2.357 0 0 1 2.4 2.4A2.357 2.357 0 0 1 8 7.2a2.357 2.357 0 0 1-2.4-2.4A2.357 2.357 0 0 1 8 2.4Zm0 11.36a5.836 5.836 0 0 1-4.8-2.56c0-1.6 3.2-2.48 4.8-2.48s4.8.88 4.8 2.48A5.836 5.836 0 0 1 8 13.76Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgHomeAndUtilityInfo;
